export default __webpack_public_path__ + "static/media/missioncontrol_demo_image.63ac4c2f.jpg";